import api from '../../services/api';

/**
 * The URL an app expects to be handed back to after consent.
 *
 * EXTRACTED SO BOTH PATHS USE IT. The free grant built this inline and the paid return
 * page did not build it at all — it navigated to Paradigm's own app list in both
 * branches of an `if (redirectUri)`, with a comment claiming it handed back "the same
 * way a free grant does". It did not, and the consequence was specific: ink, missions,
 * story and entropy all gate on `code === 'success'` and bounce to `?error=auth_failed`
 * without it, so a person who PAID was left with a working grant, no way back, and an
 * app that never learned consent had happened.
 *
 * `sid_code` is best effort: an app with no session support still receives user_id.
 */
export async function buildAppCallbackUrl(redirectUri, clientId, user, { joined = false } = {}) {
  let sidCode;
  try { sidCode = (await api.startAppSession(clientId))?.code; }
  catch { /* older Paradigm, or no session support — EP-only, as before */ }
  return appCallbackUrl({
    redirectUri, clientId, userId: user?.id, username: user?.username, sidCode, joined,
  });
}

/**
 * The same URL, from values already in hand.
 *
 * /connect logs a person into an app they have already authorized, so it holds
 * the session code and the identity before it builds anything — from the server,
 * which is the only place both are certainly known. It must still hand back the
 * EXACT shape consent does, because an app cannot tell the two apart and should
 * not have to: `code === 'success'` is what ink, missions, story and entropy all
 * gate on. One builder, so the two can never drift into two dialects.
 */
//
// `joined=1` says this person joined ofSelf on the way here (pages/join): the
// app can skip its own "welcome" (Nucleus already said it) and start at its
// first real step. An app that does not read it loses nothing.
export function appCallbackUrl({ redirectUri, clientId, userId, username, sidCode, joined = false }) {
  const sep = redirectUri.includes('?') ? '&' : '?';
  let url = `${redirectUri}${sep}code=success&client_id=${encodeURIComponent(clientId || '')}`
    + `&user_id=${encodeURIComponent(userId || '')}`
    + `&username=${encodeURIComponent(username || '')}`;
  if (sidCode) url += `&sid_code=${encodeURIComponent(sidCode)}`;
  if (joined) url += '&joined=1';
  return url;
}
